import { useEffect, useState } from 'react'
import { AlternativesQuestionModel } from '../../../domain/models'

import { Checkbox } from '..'

import * as S from './styles'

type CheckboxQuestionProps = {
  label: string
  options: AlternativesQuestionModel[]
  optionChecked: AlternativesQuestionModel[]
  order: number
  onChange: (values: any) => void
}

const CheckboxQuestion = ({
  label,
  options,
  order,
  optionChecked,
  onChange
}: CheckboxQuestionProps) => {
  const [valuesToCheckbox, setValuesToCheckbox] = useState<any>()

  useEffect(() => {
    if (optionChecked) {
      setValuesToCheckbox(optionChecked)
    }
  }, [optionChecked])

  return (
    <S.Wrapper>
      <S.Title>{label}</S.Title>
      {options.map((option) => (
        <Checkbox
          key={option.cdAlternativa}
          name={`${order}-${option.alternativa}`}
          label={option.alternativa}
          labelFor={option.alternativa}
          isChecked={
            !!optionChecked?.find(
              (opt) => opt?.cdAlternativa === option?.cdAlternativa
            )
          }
          onCheck={(e) => {
            if (e) {
              setValuesToCheckbox((prev: any) => ({
                ...prev,
                [option.alternativa]: {
                  cdAlternativa: option.cdAlternativa,
                  alternativa: option.alternativa
                }
              }))
              onChange({
                ...valuesToCheckbox,
                [option.alternativa]: {
                  cdAlternativa: option.cdAlternativa,
                  alternativa: option.alternativa
                }
              })
            } else {
              const newValuesCheckbox = valuesToCheckbox?.filter(
                (i: any) => i?.cdAlternativa !== option?.cdAlternativa
              )

              setValuesToCheckbox(newValuesCheckbox)
              onChange({ ...newValuesCheckbox })
            }
          }}
        />
      ))}
    </S.Wrapper>
  )
}

export default CheckboxQuestion
